@let workspace = workspaceSg();
@let conversations =
  assistantGroup.getWorkspaceGroup(workspaceSg().id).asSignal()?.entities ?? [];
@let isExpanded = isExpandedSg();
@let deletedWorkspace =
  assistantGroup.workspace.plugins.editingPlugin.feature.selectors
    .getDeletedEntity(workspace.id)
    .asSignal();
@let editedWorkspace =
  assistantGroup.workspace.plugins.editingPlugin.feature.selectors
    .getEditedEntity(workspace.id)
    .asSignal();

@let isSubmitting =
  assistantGroup.workspace.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();

<div
  class="workspace-item"
  [class.workspace-item--expanded]="isExpanded"
>
  <!-- Workspace Header -->
  <div
    class="workspace-item__header"
    (click)="isExpandedSg.set(!isExpanded)"
  >
    <i
      class="atn-icon workspace-item__chevron {{
        isExpanded ? 'atn-angle-down' : 'atn-angle-right'
      }} atn-blue"
    ></i>
    <i class="atn-icon atn-folder atn-yellow workspace-item__folder-icon"></i>
    <span class="workspace-item__name">{{ workspace.name }}</span>

    <div class="workspace-item__tag-group">
      @if (isShared()) {
        <atn-ds-tag
          class="workspace-item__badge"
          [text]="isOwner() ? 'Shared' : 'Shared with me'"
          [style]="sharedTagStyle.Info"
        />
      }
    </div>

    <div class="workspace-item__actions">
      <i
        class="atn-icon atn-plus atn-blue"
        title="Create conversation in workspace"
        (click)="createConversation($event)"
      ></i>
      @if (isOwner()) {
        <i
          class="atn-icon atn-edit atn-blue"
          title="Edit workspace"
          (click)="editWorkspace($event)"
        ></i>
        <i
          class="atn-icon atn-trash atn-red"
          title="Delete workspace"
          (click)="deleteWorkspace($event)"
        ></i>
      }
    </div>
  </div>

  <!-- Conversations List (collapsible) -->
  @if (isExpanded) {
    <div class="workspace-item__conversations">
      @for (conversation of conversations; track conversation.id) {
        <atn-conversation-item [conversation]="conversation" />
      } @empty {
        <div class="workspace-item__empty">
          <span>No conversations</span>
        </div>
      }
    </div>
  }
</div>

@if (deletedWorkspace) {
  <atn-ds-confirmation-overlay
    title="Delete Workspace"
    [description]="
      'Are you sure you want to delete <b>' +
      deletedWorkspace.name +
      '</b>? This action cannot be undone.'
    "
    [validation]="deletedWorkspace.name"
    (cancel)="cancelDeleteWorkspace()"
    (confirm)="confirmDeleteWorkspace()"
    [loading]="isSubmitting"
    confirmButtonText="Delete"
  />
}

@if (editedWorkspace) {
  <atn-ds-centered-overlay>
    <atn-ds-widget title="Update Workspace">
      <i
        actions
        class="atn-icon atn-close atn-red"
        (click)="cancelEditWorkspace()"
      ></i>
      <div class="workspace-item__edit-dialog-content">
        <atn-ds-text
          label="Name"
          placeholder="Enter workspace name"
          [value]="editedWorkspace.name"
          (change)="updateWorkspace({ name: $event ?? '' })"
        ></atn-ds-text>
        <atn-ds-text
          label="Description"
          placeholder="Enter workspace description"
          [value]="editedWorkspace.description ?? ''"
          (change)="updateWorkspace({ description: $event ?? '' })"
        ></atn-ds-text>
        <atn-ds-select-multiple
          label="Shared with"
          [items]="store.userItems()"
          [config]="{ overlay: { hasSearch: true } }"
          [value]="editedWorkspace.sharedWith ?? []"
          (valueChange)="updateWorkspace({ sharedWith: $any($event) })"
        />
        <atn-ds-notice
          [style]="StyleEnum.Warning"
          description="Sharing a workspace will also share all conversations within it."
        />
      </div>
      <div
        footer
        class="workspace-item__edit-dialog-footer"
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelEditWorkspace()"
          [disabled]="isSubmitting"
        >
          Cancel
        </atn-ds-button>
        <atn-ds-button
          (click)="saveWorkspace()"
          [loading]="isSubmitting"
          >Save</atn-ds-button
        >
      </div>
    </atn-ds-widget>
  </atn-ds-centered-overlay>
}
